import BaseContainer from "@base/container/BaseContainer";
import TweenMax from "gsap";
import * as PIXI from "pixi.js";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class BulletContainer extends BaseContainer {

    constructor(data, direction) {
        super(data)
        this.direction = direction
        this.image = new PIXI.Sprite(PIXI.Texture.from(data))
        this.addChild(this.image)
        this.image.scale.set(0.7)
        this.image.visible = true

        this.explosion = new SpineAnimation('shotExplosion')
        this.addChild(this.explosion)
        this.explosion.visible = false
    }


    start() {
        this.image.visible = true
        this.explosion.visible = false

        TweenMax.to(this, 0.4, {y: 280 * this.direction, ease: "none", onComplete: () => {
                this.stop()
                this.explosion.visible = true
                this.explosion.start(['shotExplosionAnim'], [false])
            }})
    }

    stop() {
        this.image.visible = false

        setTimeout(() => {
            this.onComplete()
        }, 500)
        TweenMax.killTweensOf(this)
    }

    onComplete() {
        this.explosion.visible = false
        this.explosion.stop()
    }
}
